import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { SUPPORTED_STATES_NOTICE } from '@shared/constants/supportedStates';

/**
 * One line telling people which states Zlayt AI supports (ZLAYT-1486), for
 * sign-up and the plan pickers.
 */
const SupportedStatesNotice: FC<Pick<TypographyProps, 'sx'>> = ({ sx }) => (
  <Typography
    variant="body2"
    color="text.secondary"
    textAlign="center"
    data-testid="supported-states-notice"
    sx={sx}
  >
    {SUPPORTED_STATES_NOTICE}
  </Typography>
);

export default SupportedStatesNotice;
